module.exports = __webpack_public_path__ + "img/crossed_fingers.4c97997f.gif";